import accounts from "./accounts.svg";
import dashboard from "./dashboard.svg";
import settings from "./settings.svg";
import transactions from "./transactions.svg";
import menu from "./menu.svg";

const Icons = {
  accounts,
  dashboard,
  settings,
  transactions,
  menu,
};

export default Icons;
